import { Head } from "@inertiajs/react"
import { Flex, Heading, Text, Progress } from "@radix-ui/themes"
import { z } from "zod"

import ProjectLayout from "@/layouts/project-layout"
import { projectImportsPath } from "@/routes"
import { ImportSchema, ProjectSchema } from "@/schemas"
import { router } from "@inertiajs/core"
import { useEffect, useRef } from "react"

const PropsSchema = z.object({
  project: ProjectSchema,
  import: ImportSchema,
  headers: z.array(z.string()),
  preview_data: z.array(z.array(z.string().nullable())),
})

type Props = z.infer<typeof PropsSchema>

export default function ShowProcessingImport(props: Props) {
  const validatedProps = PropsSchema.parse(props)
  const { project, import: importData } = validatedProps
  const intervalRef = useRef<number | null>(null)

  useEffect(() => {
    console.log("setting up reloading")
    intervalRef.current = window.setInterval(() => {
      console.log("reloading")
      router.reload()
    }, 5000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  return (
    <ProjectLayout
      projectId={project.slug}
      breadcrumbs={[
        { title: project.name, href: projectImportsPath(project.slug) },
        { title: "Imports", href: projectImportsPath(project.slug) },
        { title: "Importing..." },
      ]}
    >
      <Head title="Importing..." />

      <Flex direction="column" gap="6" p="6">
        <div>
          <Heading size="6" weight="medium" mb="6">
            Importing...
          </Heading>

          <Text size="3" mb="4">
            Importing in progress, check back in a few minutes.
          </Text>

          <Progress value={importData.progress * 100} size="3" />

          <Text size="2" color="gray" mt="2">
            {Math.round(importData.progress * 100)}% complete
          </Text>
        </div>
      </Flex>
    </ProjectLayout>
  )
}
